import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=5dd0830c&"
import script from "./Cart.js?vue&type=script&lang=js&"
export * from "./Cart.js?vue&type=script&lang=js&"
import style0 from "./Cart.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports